import { nextTick } from 'vue'

export function usePopover() {
  const handlePopoverClick = async (event: MouseEvent | KeyboardEvent) => {
    await nextTick()

    // Headless UI's Popover component displays a focus indicator on click.
    // This is a workaround to prevent that from happening.
    if (event instanceof MouseEvent && document.activeElement instanceof HTMLElement) {
      document.activeElement.blur()
    }
  }

  return {
    handlePopoverClick,
  }
}
